module.exports = __webpack_public_path__ + "img/strikethrough.7d46e921.svg";